export const CHANGE_CURRENT_PAGE = 'nginxSettings/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'nginxSettings/CHANGE_PAGE_SIZE'
export const CREATE_NGINX_SETTING = 'nginxSettings/CREATE_NGINX_SETTING'
export const FETCH_NGINX_SETTINGS_LIST = 'nginxSettings/FETCH_NGINX_SETTINGS_LIST'
export const FETCH_NGINX_SETTINGS_FOR_OPTIONS = 'nginxSettings/FETCH_NGINX_SETTINGS_FOR_OPTIONS'
export const REMOVE_NGINX_SETTING = 'nginxSettings/REMOVE_NGINX_SETTING'
export const UPDATE_NGINX_SETTING = 'nginxSettings/UPDATE_NGINX_SETTING'
